import {
  usePriorityModalMeta,
  useSetPriorityModal,
} from "@/shared/atoms/usePriorityModal";
import usePosOrderPendingPaymentSocket from "@/shared/hooks/usePosOrderPendingPaymentSocket";
import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../Modal/Modal";
import Spinner from "../Spinner/Spinner";
import Button from "../Button/Button";
import usePaymentLeaveGuard from "@/shared/hooks/usePaymentLeaveGuard";
import useBranchId from "@/shared/hooks/useBranchId";
import { Prompt } from "react-router-dom";
import useAbortPinHook from "@/shared/hooks/useAbortPinHook";

export interface PendingPaymentModalMeta {
  itemId?: number;
  callback: () => void;
  eventName: string;
}

/* const duration = 45000;
const waiting = 15000; */
const PendingPaymentModal = (props: ModalProps) => {
  const { t } = useTranslation();
  const [meta] = usePriorityModalMeta();
  const { orderId, sessionId, ledgerId, isSplitPayment } = meta ?? {};
  const branchId = useBranchId();
  const abortPinMutation = useAbortPinHook(isSplitPayment);
  const setPriorityModal = useSetPriorityModal();
  usePosOrderPendingPaymentSocket(meta as PendingPaymentModalMeta);

  /**
   * @description handle user click reload button on the browser or close the browser tab
   */
  usePaymentLeaveGuard({
    orderId,
    branchId,
    sessionId,
    ledgerId,
    isSplitPayment,
  });

  /**
   * @description handle user click cancel button on the modal
   */
  const handleAbortOrder = async () => {
    if (meta?.onCancel) {
      meta?.onCancel();
    }

    return abortPinMutation.mutate(
      {
        id: sessionId ?? orderId,
        isSession: sessionId ? true : false,
        ledgerId,
      },
      {
        onSuccess: () => {
          setPriorityModal("", {});
        },
      }
    );
  };

  /**
   * @description handle user click back button on the browser
   */
  const handleUserDecision = () => {
    const confirmLeave = window.confirm(t("doNotLeaveBeforePaymentIsComplete"));
    if (confirmLeave) {
      handleAbortOrder().then(() => {
        return true;
      });
    }
    return false;
  };

  /*  const [showButton, setShowButton] = useState(false);
  const clearConfirmTimer = () => {
    if (confirmTimer.current) {
      clearTimeout(confirmTimer.current);
      confirmTimer.current = null;
    }
  };

  const isKiosk = useIsKiosk();
  const confirmTimer = useRef<ReturnType<typeof setTimeout>  | null>(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (!isKiosk || !showButton) return;
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const value = Math.min(elapsed / duration, 1);
      setProgress(value);

      if (value === 1) {
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, [duration, isKiosk, showButton]);

  const onIdle = () => {
    if (!isKiosk) return;
    setShowButton(true);
    confirmTimer.current = setTimeout(() => {
      clearConfirmTimer(); // 👈 belangrijk
      props?.onExit();
    }, duration);
  };

  const resetIdleTimer = useIdleTimer(onIdle, waiting, isKiosk);

  useEffect(() => {
    return () => {
      clearConfirmTimer();
      resetIdleTimer();
    };
  }, []); */

  return (
    <Modal width="30rem" {...props}>
      <Prompt when={true} message={handleUserDecision} />
      <div className="flex flex-col items-center justify-center gap-4 pt-12 pb-4">
        <Spinner size="0.8rem" />
        <h3>{t("paymentIsPending")}</h3>
        <h5>{t("doNotLeaveBeforePaymentIsComplete")}</h5>
      </div>
      {/* {showButton && (
        <ProgressButton
          onClick={() => {
            clearConfirmTimer(); // 👈 essentieel
            setShowButton(false);
            setProgress(0);
            resetIdleTimer();
          }}
        >
          <ProgressFill style={{ width: `${progress * 100}%` }} />
          <ButtonText>{t("yesIAmStillHere")}</ButtonText>
        </ProgressButton>
      )} */}
      <Button
        variant="danger"
        onClick={handleAbortOrder}
        isPending={abortPinMutation.isPending}
        className="w-full"
      >
        {t("cancelTheOrder")}
      </Button>
    </Modal>
  );
};

export default PendingPaymentModal;
